export const SLICE_NAME = "OCR";

